import { T as TableCellHeight } from '../../../../../common.gen-CZ1M9G8L.js';

const pluginVersion = "12.1.0-pre";
const defaultOptions = {
  cellHeight: TableCellHeight.Sm,
  footer: {
    /**
     * Controls whether the footer should be shown
     */
    show: false,
    /**
     * Controls whether the footer should show the total number of rows on Count calculation
     */
    countRows: false,
    /**
     * Represents the selected calculations
     */
    reducer: []
  },
  frameIndex: 0,
  showHeader: true,
  showTypeIcons: false,
  sortBy: []
};

export { defaultOptions, pluginVersion };
